import { render, staticRenderFns } from "./UserAclSettings.vue?vue&type=template&id=6ca25c81&scoped=true"
import script from "./UserAclSettings.vue?vue&type=script&lang=js"
export * from "./UserAclSettings.vue?vue&type=script&lang=js"
import style0 from "./UserAclSettings.vue?vue&type=style&index=0&id=6ca25c81&prod&scoped=true&lang=css"
import style1 from "./UserAclSettings.vue?vue&type=style&index=1&id=6ca25c81&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca25c81",
  null
  
)

export default component.exports